import React from 'react';
import RoomListItem from './RoomListItem';
import type { ChatRoom } from '../../types/chat';

interface RoomListProps {
  rooms: ChatRoom[];
  activeRoomId?: string | null;
  onSelect: (room: ChatRoom) => void;
  isLoading?: boolean;
  emptyHint?: string;
}

const RoomList: React.FC<RoomListProps> = ({
  rooms,
  activeRoomId,
  onSelect,
  isLoading,
  emptyHint = 'No conversations yet — pick a person in Contacts to start one.',
}) => {
  if (isLoading && rooms.length === 0) {
    return (
      <div className="px-3 py-2 space-y-2" aria-busy="true">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex items-center gap-3 py-2"
          >
            <div className="w-10 h-10 rounded-full bg-neutral-200 dark:bg-neutral-800 animate-pulse" />
            <div className="flex-1 min-w-0 space-y-1.5">
              <div className="h-3 w-1/2 rounded bg-neutral-200 dark:bg-neutral-800 animate-pulse" />
              <div className="h-2.5 w-3/4 rounded bg-neutral-200 dark:bg-neutral-800 animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (rooms.length === 0) {
    return (
      <div className="px-3 py-6 text-center text-xs text-text-tertiary">{emptyHint}</div>
    );
  }

  return (
    <div className="flex flex-col gap-0.5 px-1.5 pb-3">
      {rooms.map((room) => (
        <RoomListItem
          key={room.id}
          room={room}
          active={room.id === activeRoomId}
          onClick={() => onSelect(room)}
        />
      ))}
    </div>
  );
};

export default RoomList;
